import React, {useState} from "react";
import UI from "components/UI";
import { Link , useLocation, useHistory } from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import UIInput from 'components/input/input';
import Button from 'components/buttons/';
import useToggleState from 'components/hooks/useToggleState';
import ModalPopup from 'components/modal/';
//import 'react-tooltip/dist/react-tooltip.css'
import { Tooltip } from 'react-tooltip';
import CommonUtil from "utils/CommonUtil";
import codeDataStore from "common/codedata/store/CodeDataStore";
import StringUtil from "utils/StringUtil";
import UIUtils from "../../../../utils/UIUtils";
import CodeDataStore from "../../../../common/codedata/store/CodeDataStore";
import UISelect from "../../../../components/selectbox/UISelect";
import userRestRepository from "../../../../common/user/repository/UserRestRepository";
import TbComFile from "domain/main/com/file/TbComFile";
import TbComFileMapngDetail from "../../../../domain/main/com/file/mapng/TbComFileMapngDetail";

//import { Popover } from "react-tiny-popover";
function ContentsContainer() {
	const modaladm2004 = useToggleState({});
	//const [isPopoverOpen, setIsPopoverOpen] = useState(false);
	const [corpInfo, setCorpInfo] = useState<any>({});
	const location = useLocation();
	const receivedData = (location.state as any)?.data;
	const history = useHistory();

	const [bizNo ,setBizNo] = useState('');
	const [bizCd ,setBizCd] = useState('');
	const [donNo ,setDonNo] = useState('');
	const [elec, setElec] = useState('');
	const [receNo, setReceNo] = useState('');

	const [emailDomain, setEmailDomain] = useState('');
	const [emailName, setEmailName] = useState('');
	const [emailId, setEmailId] = useState('');

	//밑에 담당자 정보
	const [corpNm,setCorpNm] = useState(''); //과제명
	const [corpRegNo,setCorpRegNo] = useState(''); //사업자번호
	const [personNm,setPersonNm] = useState(''); //이름
	const [posiNm,setPosiNm] = useState(''); //직급
	const [deptNm,setDeptNm] = useState(''); //부서명
	const [emailAdres,setEmailAdres] = useState(''); //이메일
	const [ofcTelNo,setOfcTelNo] = useState(''); //전화번호

	const serverUrl = 'http://dev.fund.win-win.or.kr/';

	//파일정보 선언
	const [reqFileNm, setReqFileNm] = useState('');
	const [planFileNm, setPlanFileNm] = useState('');
	const [bizFileNm, setBizFileNm] = useState('');

	const [corpLogoFileValue] = useState(new TbComFile());
	const [bizLicFileValue] = useState(new TbComFile());
	const [fileValue] = useState(new TbComFile());

	// REQ - 신청서, PLAN - 계획서, 수행기관 사업자 등록증 - BIZ
	const [reqFileValue] = useState(new TbComFile());
	const [planFileValue] = useState(new TbComFile());
	const [bizFileValue] = useState(new TbComFile());
	const [otherFiles] = useState(new TbComFile());

	const [uploadComp, setUploadComp] = useState(false);
	const [fileInfoList, setFileInfoList] = React.useState<any[]>([]);
	const [uploadComp2103, setUploadComp2103] = useState(false);
	const [uploadComp2104, setUploadComp2104] = useState(false);
	const [fileInfoList2103, setFileInfoList2103] = React.useState<any[]>([]);
	const [fileInfoList2104, setFileInfoList2104] = React.useState<any[]>([]);
	const [fileInfoListPop, setFileInfoListPop] = React.useState<any[]>([]);

	//파일업로드
	const [uploadId, setUploadId] = React.useState("");
	const [reduReceNo, setReduReceNo] = useState('');


	async function deleteDon(){
		if(await UIUtils.confirm('삭제 하시겠습니까?')){
			let param = {
				"DON_NO": receivedData.vDON_NO,
				"BIZ_CD": receivedData.vBIZ_CD
			};

			const response:any = await CommonUtil.execute({
				url:'usr_2004_delete',
				data: param
			})

			const result = response;

			UIUtils.alert('삭제 되었습니다.').then();
			// 다른 페이지로 이동하면서 데이터 전달
			history.push({
				pathname: './usr_2002',
				state: { data: receivedData }
			});
		}


	}
	async function updateDon(type){
		let msg = '파일 업로드를 위해 수정페이지로 이동합니다.';
		if(type == 'U') msg = '수정하시겠습니까?';
		if(await UIUtils.confirm(msg)){
			let dataToSend = {
				"vDON_NO": receivedData.vDON_NO,
				"vBIZ_NO": receivedData.vBIZ_NO,
				"vBIZ_CD": receivedData.vBIZ_CD
			};

			// 다른 페이지로 이동하면서 데이터 전달
			history.push({
				pathname: './usr_2006',
				state: { data: dataToSend }
			});
		}
	}

	async function initCall(){

		//console.log("bizNo " +receivedData.vBIZ_NO);
		//let bizNo = receivedData.vBIZ_NO;

		let param2 = {
			"DON_NO" : receivedData.vDON_NO
		};

		//파라미터 전송
		const response2:any = await CommonUtil.execute({
			url:'adm_3200',
			data: param2
		})

		const result2 = response2;
		if(result2.REC.length != 0) setReceNo(result2.REC[0].RECE_NO);
		
		if(result2.REC[0].RECE_NO.indexOf(',') != -1){
			let splitList = result2.REC[0].RECE_NO.split(','); 
			setReduReceNo(splitList[0]+" 외 "+(splitList.length-1)+"건");
		}else{
			// @ts-ignore
			setReduReceNo(result2.REC[0].RECE_NO);
		}
		

		let param = {
			"DON_NO": receivedData.vDON_NO,
			"BIZ_NO": receivedData.vBIZ_NO,
			"BIZ_CD": receivedData.vBIZ_CD
		};

		const response:any = await CommonUtil.execute({
			url:'usr_2004',
			data: param
		})

		const result = response;
		setCorpInfo(result);


		// REQ - 신청서, PLAN - 계획서, 수행기관 사업자 등록증 - BIZ
		otherFiles.setTbComFileMapngDetailList([]);
		reqFileValue.setTbComFileMapngDetailList([]);
		let fileList = result.FILE_INFO;
		for(let i = 0; i < fileList.length; i++){
			if(fileList[i].FILE_GB == 'REQ'){
				let reqFileInfo = fileList[i];

				//파일등록 정보
				const fileDetail = new TbComFileMapngDetail();
				fileDetail.setDwldId(reqFileInfo.DWLD_ID);
				fileDetail.setFileDetailId(reqFileInfo.FILE_DETAIL_ID);
				fileDetail.setFilePolicy(reqFileInfo.FILE_POLICY);
				fileDetail.setFileRpstr(reqFileInfo.FILE_RPSTR);
				fileDetail.setStrePath(reqFileInfo.STRE_PATH);
				fileDetail.setStreFileNm(reqFileInfo.STRE_FILE_NM);
				fileDetail.setOrginlFileNm(reqFileInfo.ORGINL_FILE_NM);
				fileDetail.setFileExtsn(reqFileInfo.FILE_EXTSN);
				fileDetail.setFileSize(reqFileInfo.FILE_SIZE);
				fileDetail.setRegistPsnNm(reqFileInfo.REGIST_PSN_NM);
				fileDetail.setRegistDt(reqFileInfo.REGIST_DT);
				reqFileValue.putTbComFileMapngDetailList(fileDetail);
				setReqFileNm(reqFileInfo.ORGINL_FILE_NM);

			}else{
				let otherFileInfo = fileList[i];

				//파일등록 정보
				const fileDetail = new TbComFileMapngDetail();
				fileDetail.setDwldId(otherFileInfo.DWLD_ID);
				fileDetail.setFileDetailId(otherFileInfo.FILE_DETAIL_ID);
				fileDetail.setFilePolicy(otherFileInfo.FILE_POLICY);
				fileDetail.setFileRpstr(otherFileInfo.FILE_RPSTR);
				fileDetail.setStrePath(otherFileInfo.STRE_PATH);
				fileDetail.setStreFileNm(otherFileInfo.STRE_FILE_NM);
				fileDetail.setOrginlFileNm(otherFileInfo.ORGINL_FILE_NM);
				fileDetail.setFileExtsn(otherFileInfo.FILE_EXTSN);
				fileDetail.setFileSize(otherFileInfo.FILE_SIZE);
				fileDetail.setRegistPsnNm(otherFileInfo.REGIST_PSN_NM);
				fileDetail.setRegistDt(otherFileInfo.REGIST_DT);
				otherFiles.putTbComFileMapngDetailList(fileDetail);
			}
		}

		if(result.ELEC_APPR_YN == 'Y'){
			setElec("전자인증")
		}else if(reqFileValue.tbComFileMapngDetailList.length != 0){
			setElec("서면")
		}else{
			setElec("미제출")
		}

		let param3 = {
			"PERSON_ID":  result.REG_USERID
		};

		console.log(result.REG_USERID);

		const response1:any = await CommonUtil.execute({
			url:'TbComPersonEntityMapper_select_person',
			data: param3
		})

		const result1 = response1;
		console.log(result)

		setCorpNm(result1.CORP_NM);
		setBizNo(result1.BIZ_NO);
		setCorpRegNo(result1.CORP_REG_NO);
		setPersonNm(result1.PERSON_NM);
		setEmailName(result1.PERSON_NM);
		setPosiNm(result1.POSI_NM);
		setDeptNm(result1.DEPT_NM);
		setEmailAdres(result1.EMAIL_ADRES);
		setOfcTelNo(result1.OFC_TEL_NO);

		let emailInfo = result1.EMAIL_ADRES.split('@');
		setEmailId(emailInfo[0]);
		setEmailDomain(emailInfo[1])

		// @ts-ignore
		if(typeof corpInfo == 'undefined'){
			alert('data is not loaded!!!')
			return;
		}
	};

	function dateLpad(num){
		if(num.toString().length == 1){
			num = "0"+num;
		}

		return num;
	}

	function dueDateConverter(dueDate, type){
		if(dueDate == null) return '';

		if(type == 'date'){
			dueDate = dateToStr(dueDate);
			return dueDate.substring(0, 10);
		}else if(type == 'diff'){
			if(/^(-?)[0-9]+$/.test(dueDate)){
				dueDate = Number(dueDate);
			}

			const due = new Date(dueDate);
			const now = new Date();
			const timeGap = due.getTime() - now.getTime();

			// 남은 일수 카운트
			const remainDay = Math.ceil(timeGap / (1000 * 60 * 60 * 24));
			return '('+remainDay+'일)';
		}

		return '';
	}

	function dateToStr(dateText) {

		if(dateText == null) return '';

		if(/^(-?)[0-9]+$/.test(dateText)){
			dateText = Number(dateText);
		}
		let date = new Date(dateText);
		let week = new Array('일', '월', '화', '수', '목', '금', '토');


		let year = date.getFullYear();
		let month = date.getMonth()+1;
		let day = date.getDate();
		let dayName = week[date.getDay()];

		return year+'-'+dateLpad(month)+'-'+dateLpad(day)+'('+dayName+')';
	}

	async function sendEmail(){
		if (await UIUtils.confirm('가상계좌확인서 발급 요청 하시겠습니까?')) {
			let param = {
				"EMAIL_NAME": personNm,
				"EMAIL": emailAdres
			};

			const response:any = await CommonUtil.execute({
				url:'usr_2004_email',
				data: param
			}).then((response: any) => {
                UIUtils.alert('정상처리되었습니다.').then();
            })
            .catch((error) => {
                CommonUtil.showAxiosError(error);
            });

		}


	}

	React.useEffect(() => {
		//넘어온 파라미터 바인딩
		if(receivedData !==undefined){
			setBizNo(StringUtil.defaultString(receivedData.vBIZ_NO));
			setBizCd(StringUtil.defaultString(receivedData.vBIZ_CD));
			setDonNo(StringUtil.defaultString(receivedData.vDON_NO));
			initCall();

		}

		CodeDataStore.read("[EMAIL]");



	}, [])//effect

	async function startCertify(){
		const result = await userRestRepository.certify("전자서명값");

		//전자인증수정
		if(result.result){
			updateElec();
		}
	}

	async function updateElec(){
		let param = {
			"DON_NO": donNo,
			"ELEC_APPR_YN": "Y"
		};

		const response:any = await CommonUtil.execute({
			url:'usr_2004_elec',
			data: param
		}).then((response: any) => {
			UIUtils.alert('정상처리되었습니다.').then();
			initCall();
			return;
		}).catch((error) => {
			CommonUtil.showAxiosError(error);
			return;
		});
	}

	function getOzReport(){
		//체크박스 체크된 row만 가져오기
		let maxRow = 50;

		let receNoList = [];

		if(receNo.indexOf(',') != -1){
			let splitList = receNo.split(',');
			for(let j = 0; j < splitList.length; j++){
				// @ts-ignore
				receNoList.push(splitList[j]);
			}
		}else{
			// @ts-ignore
			receNoList.push(receNo);
		}

		if(receNoList.length > maxRow){
			UIUtils.alert('영수증번호 기준 최대 '+maxRow+'개를 초과할수없습니다. 시스템 관리자에게 문의 하세요').then();
			return false;
		}else{
			let dummy = maxRow - receNoList.length;
			for(let i = 0; i < dummy; i++){
				// @ts-ignore
				receNoList.push('');
			}
		}

		UIUtils.openOZReportViewerPopup({
			title: "기부금영수증",
			reportName: "rece_receipt",
			parameter: {
				"odi.odinames": "rece_receipt",
				"odi.rece_receipt.pcount": "50",
				"odi.rece_receipt.args1": "rece_no1=" + receNoList[0],
				"odi.rece_receipt.args2": "rece_no2=" + receNoList[1],
				"odi.rece_receipt.args3": "rece_no3=" + receNoList[2],
				"odi.rece_receipt.args4": "rece_no4=" + receNoList[3],
				"odi.rece_receipt.args5": "rece_no5=" + receNoList[4],
				"odi.rece_receipt.args6": "rece_no6=" + receNoList[5],
				"odi.rece_receipt.args7": "rece_no7=" + receNoList[6],
				"odi.rece_receipt.args8": "rece_no8=" + receNoList[7],
				"odi.rece_receipt.args9": "rece_no9=" + receNoList[8],
				"odi.rece_receipt.args10": "rece_no10=" + receNoList[9],
				"odi.rece_receipt.args11": "rece_no11=" + receNoList[10],
				"odi.rece_receipt.args12": "rece_no12=" + receNoList[11],
				"odi.rece_receipt.args13": "rece_no13=" + receNoList[12],
				"odi.rece_receipt.args14": "rece_no14=" + receNoList[13],
				"odi.rece_receipt.args15": "rece_no15=" + receNoList[14],
				"odi.rece_receipt.args16": "rece_no16=" + receNoList[15],
				"odi.rece_receipt.args17": "rece_no17=" + receNoList[16],
				"odi.rece_receipt.args18": "rece_no18=" + receNoList[17],
				"odi.rece_receipt.args19": "rece_no19=" + receNoList[18],
				"odi.rece_receipt.args20": "rece_no20=" + receNoList[19],
				"odi.rece_receipt.args21": "rece_no21=" + receNoList[20],
				"odi.rece_receipt.args22": "rece_no22=" + receNoList[21],
				"odi.rece_receipt.args23": "rece_no23=" + receNoList[22],
				"odi.rece_receipt.args24": "rece_no24=" + receNoList[23],
				"odi.rece_receipt.args25": "rece_no25=" + receNoList[24],
				"odi.rece_receipt.args26": "rece_no26=" + receNoList[25],
				"odi.rece_receipt.args27": "rece_no27=" + receNoList[26],
				"odi.rece_receipt.args28": "rece_no28=" + receNoList[27],
				"odi.rece_receipt.args29": "rece_no29=" + receNoList[28],
				"odi.rece_receipt.args30": "rece_no30=" + receNoList[29],
				"odi.rece_receipt.args31": "rece_no31=" + receNoList[30],
				"odi.rece_receipt.args32": "rece_no32=" + receNoList[31],
				"odi.rece_receipt.args33": "rece_no33=" + receNoList[32],
				"odi.rece_receipt.args34": "rece_no34=" + receNoList[33],
				"odi.rece_receipt.args35": "rece_no35=" + receNoList[34],
				"odi.rece_receipt.args36": "rece_no36=" + receNoList[35],
				"odi.rece_receipt.args37": "rece_no37=" + receNoList[36],
				"odi.rece_receipt.args38": "rece_no38=" + receNoList[37],
				"odi.rece_receipt.args39": "rece_no39=" + receNoList[38],
				"odi.rece_receipt.args40": "rece_no40=" + receNoList[39],
				"odi.rece_receipt.args41": "rece_no41=" + receNoList[40],
				"odi.rece_receipt.args42": "rece_no42=" + receNoList[41],
				"odi.rece_receipt.args43": "rece_no43=" + receNoList[42],
				"odi.rece_receipt.args44": "rece_no44=" + receNoList[43],
				"odi.rece_receipt.args45": "rece_no45=" + receNoList[44],
				"odi.rece_receipt.args46": "rece_no46=" + receNoList[45],
				"odi.rece_receipt.args47": "rece_no47=" + receNoList[46],
				"odi.rece_receipt.args48": "rece_no48=" + receNoList[47],
				"odi.rece_receipt.args49": "rece_no49=" + receNoList[48],
				"odi.rece_receipt.args50": "rece_no50=" + receNoList[49],
				"information.debug":"true", // 콘솔정보(Ctrl+Z) 표시 여부
				// "toolbar.first":"true", // 첫페이지 이동 아이콘 표시
				// "toolbar.last":"true", // 마지막페이지 이동 아이콘 표시

				"pdf.fontembedding":"true", // PDF 폰트포함 (글꼴 깨지는것 방지)
				"pdf.fontembedding_subset":"true", // 폰트의 서브셋을 저장할지 여부

				"export.format":"pdf", // 저장포맷
				"export.filename": "기부금영수증" + ".pdf", // 파일명
				"export.mode":"silent", // 설정창 보여줄지 여부

				"viewer.pagedisplay":"continuous", // 페이지 표시 옵션
				"viewer.viewmode":"normal", // 보고서 보기 모드
				"viewer.zoom": "90"
			},
			onClose: () => {
				console.log("Report Viewer Close");
			}
		})

	}

	function getOzReportReq(){

		UIUtils.openOZReportViewerPopup({
			title: "출연신청서",
			reportName: "don_req",
			parameter: {
				"odi.odinames": "don_req",
				"odi.don_req.pcount": "1",
				"odi.don_req.args1": "don_no=" + donNo,
				"information.debug":"true", // 콘솔정보(Ctrl+Z) 표시 여부
				// "toolbar.first":"true", // 첫페이지 이동 아이콘 표시
				// "toolbar.last":"true", // 마지막페이지 이동 아이콘 표시

				"pdf.fontembedding":"true", // PDF 폰트포함 (글꼴 깨지는것 방지)
				"pdf.fontembedding_subset":"true", // 폰트의 서브셋을 저장할지 여부

				"export.format":"pdf", // 저장포맷
				"export.filename": "출연신청서" + ".pdf", // 파일명
				"export.mode":"silent", // 설정창 보여줄지 여부

				"viewer.pagedisplay":"continuous", // 페이지 표시 옵션
				"viewer.viewmode":"normal", // 보고서 보기 모드
				"viewer.zoom": "90"
			},
			onClose: () => {
				console.log("Report Viewer Close");
			}
		})
	}


	const subjTemplateDownload = () => {
		console.log("subjTemplateDownload");
		CommonUtil.downloadTemplateFile("don_req.hwp", "양식_대중소기업_상생협력기금_출연신청서.hwp");

	};


	return (
		<PageContainer>
			<LayoutAside />
			<div className='fww-con'>
				<ul className="fww-brd">
					<li><Link to="/main/">홈</Link></li>
					<li><Link to="#">기금출연</Link></li>
					<li><Link to="#">출연현황</Link></li>
				</ul>
				<main className="fww-main">
					<h1 className="tx tx-hd2">출연현황</h1>
					<section className="fund-section">
						<h3 className="section-title mb15">출연 신청 정보</h3>
						<form className="fo fo-col2" name="" action="" method="">
							<div className="inner">
								<div className="fo-item">
									<p className="fo-key">출연번호</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={corpInfo.DON_NO_FMT} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">출연상태</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={corpInfo.DON_PROC_STS_NM} placeholder={''} readOnly={true} />
									</div>
								</div>

								<div className="fo-item">
									<p className="fo-key">출연사업</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={corpInfo.BIZ_NM} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">출연 신청일</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={dateToStr(corpInfo.DON_REQ_DATE)} placeholder={''} readOnly={true} />
									</div>
								</div>

								<div className="fo-item">
									<p className="fo-key">출연 일자</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={dateToStr(corpInfo.DON_DATE)} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">기부금 영수증번호</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={reduReceNo} placeholder={''} readOnly={true} />
									</div>
								</div>

								<div className="fo-item">
									<p className="fo-key">전자인증 여부</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={elec} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">기부내용</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={corpInfo.DON_CONT_DIV_NM} placeholder={''} readOnly={true} />
									</div>
								</div>

								<div className="fo-item">
									<p className="fo-key">출연금 입금계좌</p>
									<div className="fo-value">
										<div className="hz-root hz-left hz-gap5">
											<UIInput className={'w215 hz-fg tf tf-md'} value={'하나은행 '+corpInfo.ACCT_NO_DES} placeholder={''} readOnly={true} />
											{/*<div className="hz-item">
												<Button color='pri-o' size="md" onClick={() => sendEmail()}>가상계좌확인서 발급 요청</Button>
											</div>*/}
										</div>
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">3년 만기 도래일</p> {/*년도에 +3년*/}
									<div className="fo-value">
										<div className="hz-root hz-left hz-gap5">
											<UIInput className={'w120 hz-fg tf tf-md'} value={dueDateConverter(corpInfo.DUE_DATE, 'date')} placeholder={''} readOnly={true} />
											<div className="hz-item tx-msg">{dueDateConverter(corpInfo.DUE_DATE, 'diff')}</div>
										</div>
									</div>
								</div>

								<div className="fo-item">
									<p className="fo-key">출연신청금액(원)</p>
									<div className="fo-value">
										<div className="hz-root hz-gap5 w100p">
											<UIInput className={'tf ta-right w100p'} value={StringUtil.formatNumber(Number(corpInfo.DON_REQ_AMT)) || "0"} placeholder={''} readOnly={true} />
											<span className="fc-pri tx-msg hz-item">({StringUtil.isNotEmpty(corpInfo.DON_REQ_AMT + "") ? StringUtil.numKorPattern(Number(corpInfo.DON_REQ_AMT)) + " 원" : "원"})</span>
										</div>
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">출연금액(원)</p>
									<div className="fo-value">
										<div className="hz-root hz-gap5 w100p">
											{ corpInfo.DON_PROC_STS_CD === 'G' &&
												<UIInput className={'tf ta-right w100p'} value={StringUtil.formatNumber(Number(corpInfo.DON_AMT)) || "0"} placeholder={''} readOnly={true} />
											}
											{ corpInfo.DON_PROC_STS_CD === 'G' &&
												<span className="fc-pri tx-msg hz-item">({StringUtil.isNotEmpty(corpInfo.DON_AMT + "") ? StringUtil.numKorPattern(Number(corpInfo.DON_AMT)) + " 원" : "원"})</span>
											}
										</div>
									</div>
								</div>

								<div className="fo-item">
									<p className="fo-key">기금사용용도</p> {/*2024.10.16 추가*/}
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={corpInfo.FUN_PUR_USE_NM} placeholder={''} readOnly={true} />
									</div>
								</div>

							</div>
						</form>
						<div className="tx-msg">※ 출연신청 후 별도 승인절차가 없습니다. 위 계좌로 입금해주시면 됩니다. 단 출연금을 한번에 입금하지 않고 분할해서 입금하시는 경우 입금일자가 서로 다르면 취소하고 다시 신청해야 합니다.</div>
					</section>

					<section className="fund-section">
						<div className="hz-root hz-sb mb15">
							<h3 className="section-title hz-item">첨부파일</h3>
							{ corpInfo.DON_PROC_STS_CD != 'G' &&
								<Button color='gray-o' size="sm" onClick={() => updateDon('F')}>첨부파일수정</Button>
							}
						</div>
						<form className="fo fo-col2 mb18" name="" action="" method="">
							<div className="inner">
								{ corpInfo.ELEC_APPR_YN =='N' && reqFileValue.tbComFileMapngDetailList.length == 0 &&
									<div className="fo-item fo-m-1-3">
										<div className="fo-key">
											<span>출연신청서</span>&nbsp;
											<button type="button" className="button-tooltip" data-tooltip-id="tooltip">툴팁</button>
											<Tooltip
												id="tooltip"
												disableStyleInjection={true}
												place={"bottom-start"}
												className="tooltip-conts"
												//openOnClick
											>
												<div className="msg">
													<h6 className="tooltip-title">출연 신청 시 첨부 서류</h6>
													<ul className="list-group">
														<li>서면 : 출연신청서(서면) 클릭하여 출연신청서 출력 후 직인을 찍고 스캔하여 수정버튼을 클릭하여 이동한 화면에서 출연신청(첨부문서)에 등록 후 저장하셔야 합니다.</li>
														<li>전자인증 : 기업용 공인인증서를 이용하여 출연신청서(전자인증)을 클릭하여 인증을 완료하시면 됩니다. 첨부 문서는 없습니다.</li>
													</ul>
												</div>
											</Tooltip>
										</div>
										<div className="fo-value">
											<div className="fund-form-group hz-root hz-gap5">
												<div className="fund-form-items">
													<p className="tx-msg">제출이 완료되지 않았습니다. 전자인증을 하시거나 수정 버튼을 선택하고 수정화면에서 파일을 업로드 해주세요.</p>
												</div>
												<Button color="pri-o" size="md" onClick={() => subjTemplateDownload()}>양식다운로드</Button>
												<Button color='pri-o' size="md" onClick={() => getOzReportReq()}>미리보기</Button>
												<Button color='pri-o' size="md" onClick={() => startCertify()}>전자인증</Button>
											</div>
										</div>
									</div>
								}
								{/* 전자인증한 상태 */}
								{ corpInfo.ELEC_APPR_YN =='Y' &&
									<div className="fo-item fo-m-1-3">
										<div className="fo-key">
											<span>출연신청서</span>&nbsp;
										</div>
										<div className="fo-value">
											<div className="fund-form-group">
												<div className="fund-form-items">
													<p className="tx-msg">출연신청서 전자인증을 완료하였습니다.</p>
												</div>
												<Button color='pri-o' size="md" onClick={() => getOzReportReq()}>미리보기</Button>
											</div>
										</div>
									</div>
								}
								{/* 첨부한 파일이 있는 경우 */}
								{  corpInfo.ELEC_APPR_YN =='N' && reqFileValue.tbComFileMapngDetailList.length != 0 &&
									<div className="fo-item fo-m-1-3">
										<div className="fo-key">
											<span>출연신청서</span>&nbsp;
										</div>
										<div className="fo-value">
											<div className="fund-form-group">
												<div className="fund-form-items">
													<UI.FileDownloadSimpleMode value={reqFileValue} viewMode={"fund-download"}/>
												</div>
												<Button color='pri-o' size="md" onClick={() => startCertify()}>전자인증</Button>
											</div>
										</div>
									</div>
								}
							</div>
							<UI.FileDownload value={otherFiles}></UI.FileDownload>
						</form>
					</section>
					<section className="fund-section">
						<h3 className="section-title mb15">기업 정보</h3>
						<form className="fo fo-col2" name="" action="" method="">
							<div className="inner">
								<div className="fo-item">
									<p className="fo-key">기업명</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={corpNm} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">법인사업자번호</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={corpRegNo} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">사업자번호</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={StringUtil.bizCrpFormat(bizNo)} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item req">
									<p className="fo-key">담당자</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={personNm} valueChanged={(value) => {setPersonNm(value)}} placeholder={''} readOnly={true}/>
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">직급</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={posiNm} valueChanged={(value) => {setPosiNm(value)}} placeholder={''} readOnly={true}/>
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">부서</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={deptNm} valueChanged={(value) => {setDeptNm(value)}} placeholder={''} readOnly={true}/>
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">이메일</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={emailAdres} valueChanged={(value) => {setEmailAdres(value)}} placeholder={''} readOnly={true}/>
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">전화번호</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={StringUtil.telephoneFormat(ofcTelNo)} valueChanged={(value) => {setOfcTelNo(value)}} placeholder={''} readOnly={true} />
									</div>
								</div>
							</div>
						</form>
					</section>
					{/*버튼목록*/}
					{/*
					<option value="A">신청</option>
					<option value="E">입금확인중</option>
					<option value="G">수납완료</option>
					*/}
					<div className="hz-root hz-right hz-gap10 mt30">
						{ corpInfo.DON_PROC_STS_CD === 'A' &&
							<div className="hz-root hz-right hz-gap10 mt30">
								<Button color="pri-o2" size="md" onClick={() => updateDon('U')}>수정</Button>
								<Button color="gray-o" size="md" onClick={() => deleteDon()}>삭제</Button>
								<Button color="gray-o" size="md" href="/main/usr_2000/usr_2002">목록</Button>
							</div>
						}
						{ corpInfo.DON_PROC_STS_CD === 'E' &&
							<div className="hz-root hz-right hz-gap10 mt30">
								<Button color="pri-o2" size="md" onClick={() => updateDon('U')}>수정</Button>
								<Button color="gray-o" size="md" href="/main/usr_2000/usr_2002">목록</Button>
							</div>
						}
						{ corpInfo.DON_PROC_STS_CD === 'G' &&
							<div className="hz-root hz-right hz-gap10 mt30">
								<Button color="pri" size="md" onClick={() => getOzReport()}>기부금영수증</Button>
								<Button color="gray-o" size="md" href="/main/usr_2000/usr_2002">목록</Button>
							</div>
						}
					</div>
				</main>
			</div>

			{/* modal - 가상 계좌 발급 안내 */}
			<ModalPopup
				open={modaladm2004.isShowing}
				title="가상계좌 발급 확인서 요청"
				size="mid"
				onClose={modaladm2004.close}
			>
				<div className="modal-con">
					<div className="virtual-account">
						<div className="guide mb15">
							아래 입력된 이메일로 가상계좌 발급 확인서를 발송합니다.<br />
							이메일을 확인 후 확인서요청 버튼을 클릭해 주세요.
						</div>
						<form className="fo fo-col2" name="" action="" method="">
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">담당자명</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={emailName} valueChanged={(value) => {setEmailName(value)}} placeholder={''} />
								</div>
							</div>
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">이메일</p>
								<div className="fo-value">
									<div className="hz-root hz-gap5 w100p">
										<UIInput className={'hz-item hz-fg tf tf-md'} value={emailId} placeholder={'메일계정 입력'} valueChanged={(value) => setEmailId(value)}/>
										<span>@</span>
										<UIInput className={'hz-item hz-fg tf tf-md'} value={emailDomain} placeholder={'메일주소 입력'} valueChanged={(value) => setEmailDomain(value)}/>
										<div className="hz-item hz-fg sl sl-md">
											<UISelect
												firstName={"sel"}
												className={'hz-item hz-fg tf tf-md'}
												value={emailDomain}
												codeData={CodeDataStore.get("[EMAIL]")}
												valueChanged={(value) => setEmailDomain(value)}
											/>
										</div>
									</div>
								</div>
							</div>
						</form>

					</div>
				</div>
				<div className="modal-bottom">
					<Button color="gray-o" size="md" onClick={() => modaladm2004.close}>취소</Button>
					<Button color="pri" size="md" onClick={() => sendEmail()}>확인서 요청</Button>
				</div>
			</ModalPopup>	
		</PageContainer>
	);
}
export default ContentsContainer;